import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService, MessageSeverity } from '../../services/alert.service';
import { AppTranslationService } from '../../services/app-translation.service';
import { SurveyService } from '../survey.service';
import { BusinessUnitService } from '../../lookups/business-unit/business-unit.service';
import { DisplayModes } from '../../models/enums';
import { HelperMethodsService } from '../../services/helper-methods.service';
import { HCPClassApiService } from '../../visits/services/hcpclass-api.service';
import { forkJoin } from 'rxjs';
import { ItemBrandService } from '../../lookups/item-brand/item-brand.service';

@Component({
  selector: 'crm-add-survey',
  templateUrl: './add-survey.component.html',
  styleUrls: ['./add-survey.component.css']
})
export class AddSurveyComponent implements OnInit {
  @Output() closeEvent = new EventEmitter<boolean>();
  @Input() surveyId: number;
  displayMode: DisplayModes = DisplayModes.Success;
  survey: any = {} as any;
  businessUnits: any = {} as any;
  classes: any = {} as any;
  filteredClasses: any = {} as any;
  itemBrands: any[] = [];
  selectedBusinessUnitsIds: number[] = [];
  selectedBusinessUnits: any[] = [];
  startDate: any;
  endDate: any;
  types = [{ id: 1, name: 'HCO' }, { id: 2, name: 'HCP' }];


  constructor(private readonly surveyService: SurveyService,
    private readonly route: ActivatedRoute, private readonly businessUnitService: BusinessUnitService,
    private readonly router: Router, private readonly helperMethods: HelperMethodsService,
    private readonly translateService: AppTranslationService,
    private readonly hcpClassApiService: HCPClassApiService, private readonly itemBrandService: ItemBrandService,
    private readonly alertService: AlertService) { }

  ngOnInit() {
    this.startDate = {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate()
    };

    this.endDate = {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate()
    };

    this.displayMode = DisplayModes.Loading;
    forkJoin(this.businessUnitService.getBusinessUnitsRootLevel(true), this.hcpClassApiService.getAll())
      .subscribe(([response1, response2]) => {
        this.displayMode = DisplayModes.Success;

        this.businessUnits = response1 as any[];
        //if (this.survey && this.survey.businessUnits)
        //  this.selectedBusinessUnits = this.businessUnits.filter(bu => this.survey.businessUnits.some(sbu => sbu.businessUnitId == bu.businessUnitId));

        this.classes = response2 as any[];

        if (this.surveyId != undefined)
          this.getSurvey(this.surveyId);

      });
  }

  getSurvey(surveyId) {
    this.displayMode = DisplayModes.Loading;
    this.surveyService.getById(surveyId).subscribe(responce => {
      this.displayMode = DisplayModes.Success;
      this.survey = responce as any;

      this.survey.businessUnit = this.businessUnits.filter(bu => bu.id = this.survey.businessUnitId);

      this.survey.scores.forEach(sc => {
        sc.class = this.classes.find(c => c.id == sc.classId);
      });

      let sDate = new Date(this.survey.startDate);
      this.startDate = {
        year: sDate.getFullYear(),
        month: sDate.getMonth() + 1,
        day: sDate.getDate()
      };

      let eDate = new Date(this.survey.endDate);
      this.endDate = {
        year: eDate.getFullYear(),
        month: eDate.getMonth() + 1,
        day: eDate.getDate()
      };

      this.survey.typeData = this.types.find(t => t.id == this.survey.type);

      this.itemBrands = [];
      if (this.survey.isPerBrandSurvey) {
        this.survey.questions.forEach(q => {
          let brand = this.itemBrands.find(x => x.id == q.itemBrandId);
          if (brand == null) {
            this.itemBrands.push({ id: q.itemBrandId, name: q.itemBrandName });
            brand = this.itemBrands.find(x => x.id == q.itemBrandId);
          }
          if (brand.questions == null)
            brand.questions = [];
          brand.questions.push({ title: q.title, score: q.score, hasAnswers: q.hasAnswers, answers: q.answers });
        })
      }

      this.onChangeType();

    },
      err => {
        this.displayMode = DisplayModes.Error;
        console.log('error in get Survey');
        console.log(err);
      });
  }

  save(form) {
    if (!form.invalid && this.survey && this.survey.scores && this.survey.scores.length > 0) {
      if (this.survey.businessUnit)
        this.survey.businessUnitId = this.survey.businessUnit.id

      if (this.survey.isPerBrandSurvey && this.itemBrands) {
        this.survey.questions = [];
        this.itemBrands.forEach(b => {
          if (b.questions)
            b.questions.forEach(q => {
              let newQ = {} as any;
              newQ.itemBrandId = b.id;
              newQ.title = q.title;
              newQ.hasAnswers = q.hasAnswers;
              if (q.hasAnswers==true) {
                newQ.answers = q.answers
              }
              else {
                newQ.score = q.score
              }

              this.survey.questions.push(newQ)

            })
        })
      }

      this.survey.startDate = this.helperMethods.convertDateToUTC(new Date(this.startDate.year, this.startDate.month - 1, this.startDate.day + 1));
      this.survey.endDate = this.helperMethods.convertDateToUTC(new Date(this.endDate.year, this.endDate.month - 1, this.endDate.day + 1));
      this.survey.type = this.survey.typeData.id;

      this.survey.scores.forEach(sc => {
        sc.classId = sc.class.id;
      });

      this.displayMode = DisplayModes.Loading;
      this.alertService.startLoadingMessage("", this.translateService.getTranslation("Saving"));
      this.surveyService.save(this.survey).subscribe((res) => {
        if (res && res == true) {
          this.alertService.stopLoadingMessage();
          this.displayMode = DisplayModes.Success;
          this.alertService.showMessage("", this.translateService.getTranslation("clm.savedSuccessfully"), MessageSeverity.Success);
          this.back();
        }
        else {
          this.alertService.stopLoadingMessage();
          this.alertService.showMessage("", "You have another survey with same BU in same period", MessageSeverity.Error);
        }

      }, () => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Error;
      });
    }
  }

  back() {
    this.closeEvent.emit(true);
  }

  getBusinessUnits() {
    this.businessUnitService.getBusinessUnitsRootLevel(true).subscribe(response => {
      this.businessUnits = response as any[];
      if (this.survey && this.survey.businessUnits)
        this.selectedBusinessUnits = this.businessUnits.filter(bu => this.survey.businessUnits.some(sbu => sbu.businessUnitId == bu.businessUnitId));
    }, err => {
      console.log(err);
    });
  }

  getClasses() {
    this.hcpClassApiService.getAll().subscribe(response => {
      this.classes = response as any[];
    }, err => {
      console.log(err);
    });
  }

  onSelectAllBusinessUnits(buS) {
    this.selectedBusinessUnits = buS;
  }

  onSelectBusinessUnit() {
  }

  addQuestion() {
    if (!this.survey.questions)
      this.survey.questions = [];
    this.survey.questions.push({});
  }

  deleteQuestion(question) {
    let index = this.survey.questions.indexOf(question);
    if (index > -1) {
      this.survey.questions.splice(index, 1);
    }
  }

  addScore() {
    if (!this.survey.scores)
      this.survey.scores = [];
    this.survey.scores.push({});
  }

  deleteScore(score) {
    let index = this.survey.scores.indexOf(score);
    if (index > -1) {
      this.survey.scores.splice(index, 1);
    }
  }

  onChangeType() {
    if (this.survey.typeData.id == 1)
      this.filteredClasses = this.classes.filter(c => !c.isHcpClass);
    else
      this.filteredClasses = this.classes.filter(c => c.isHcpClass);
  }


  onChangeBU() {
    this.itemBrandService.getAllByBusinessUnitId(this.survey.businessUnit.id).subscribe(res => {
      this.itemBrands = res as any[];
    })
  }

  addQuestionBrand(brand) {
    if (!brand.questions)
      brand.questions = [];
    brand.questions.push({});
  }

  deleteQuestionBrand(brand, question) {
    let index = brand.questions.indexOf(question);
    if (index > -1) {
      brand.questions.splice(index, 1);
    }
  }

  addAnswer(question) {
    if (!question.answers)
      question.answers = [];
    question.answers.push({});
  }

  deleteAnswer(question, answer) {
    let index = question.answers.indexOf(answer);
    if (index > -1) {
      question.answers.splice(index, 1);
    }
  }


}
